import type { ViewOption } from '@/engine/app/interfaces';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';

export class SetViewOptionContourVisibilityCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private readonly _viewOption: ViewOption;

  private readonly _isVisible: boolean;

  public constructor(viewsService: ViewsService, viewOption: ViewOption, isVisible: boolean) {
    this._viewsService = viewsService;
    this._viewOption = viewOption;
    this._isVisible = isVisible;
  }

  public execute(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        object.setContourVisibility(this._isVisible);
      }
    }
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        object.setContourVisibility(!this._isVisible);
      }
    }
    return Promise.resolve(true);
  }
}
